/**
 * Utility component for rendering nothing.
 */
function RenderNothing(_) {
    return null;
}

export { RenderNothing as default };
